import { render } from "./privateBathroom.vue?vue&type=template&id=27572428"
import script from "./privateBathroom.vue?vue&type=script&lang=js"
export * from "./privateBathroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__